import { useEffect } from "react";

export const SITE_URL = "https://monteurs.x-trading.be";

const DEFAULT_DESCRIPTION =
  "Work4you koppelt monteurs, bedrijven en particulieren voor ramen- en deurenmontage. Plaats opdrachten, vind vakmensen en vraag gratis offertes aan.";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Stelt per route de <title>, meta description, canonical en robots-richtlijn in.
 * Werkt client-side; crawlers die JS renderen (Google, Semrush) pikken dit op.
 */
export function useSeo({ title, description, path, canonicalPath, noindex = false, keywords } = {}) {
  useEffect(() => {
    const desc = description || DEFAULT_DESCRIPTION;
    if (title) document.title = title;
    setMeta("name", "description", desc);
    if (keywords) setMeta("name", "keywords", keywords);

    const canonical = `${SITE_URL}${canonicalPath ?? path ?? window.location.pathname}`;
    setCanonical(canonical);

    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");

    const ogImage = `${SITE_URL}/og-image.jpg`;
    // Open Graph / social
    setMeta("property", "og:title", title || "Work4you");
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:site_name", "Work4you");
    setMeta("property", "og:locale", "nl_BE");
    // Twitter card
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title || "Work4you");
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", ogImage);

    return () => {
      // robots terugzetten naar index,follow zodat een publieke pagina na een
      // noindex-pagina niet per ongeluk noindex blijft.
      setMeta("name", "robots", "index,follow");
      // keywords opruimen zodat regio-keywords niet naar andere routes lekken.
      const kw = document.head.querySelector('meta[name="keywords"]');
      if (kw) kw.remove();
    };
  }, [title, description, path, canonicalPath, noindex, keywords]);
}
